import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, of, tap } from 'rxjs';
import { ApiRoutes } from '../../../shared/constants/api-routes';
import { CacheExpiredError } from '../../models/cache/cache-expired.error';
import { GamesCache } from '../../models/cache/games-cache';
import { Game } from '../../models/responses/game';
import { Theme } from '../../models/responses/theme';

@Injectable({ providedIn: 'root' })
export class GamesService {
  private readonly http = inject(HttpClient);

  getAll(): Observable<Game[]> {
    try {
      return of(new GamesCache().get());
    } catch (error) {
      if (!(error instanceof CacheExpiredError)) {
        throw error;
      }
      return this.requestGetAll().pipe(tap((games) => new GamesCache(games).create()));
    }
  }

  /** Temas do jogo (`GET /games/{idGame}/themes`), em ordem alfabética. */
  getThemes(idGame: string): Observable<Theme[]> {
    return this.http.get<Theme[]>(ApiRoutes.games.getThemes(idGame));
  }

  private requestGetAll(): Observable<Game[]> {
    return this.http.get<Game[]>(ApiRoutes.games.getAll());
  }
}
